module.exports = __webpack_public_path__ + "static/pataiji-e4cc8699ed428c94cf90c8a1cd032700.jpg";